<div class="callback-container">
  <div class="callback-card">
    <h2>Connexion…</h2>
    <p>Traitement du callback d’authentification.</p>
  </div>
</div>
